import { processElement } from './cursor/cursor.ts'

function createReference(
    to: string,
    name: string,
    className: string[],
): HTMLAnchorElement {
    const a = document.createElement('a')
    a.classList.add(...className)

    a.href = '#' + to
    a.innerText = name.trim()

    return a
}

function createSkillReference(to: string, name: string): HTMLAnchorElement {
    const a = createReference(to, name, ['skill-reference'])

    a.dataset.cursor = 'up'

    processElement(a)
    return a
}

function createProjetReference(to: string, name: string): HTMLAnchorElement {
    const a = createReference(to, name, ['project-reference'])

    a.dataset.cursor = 'down'

    processElement(a)
    return a
}

export function linkSkillsAndProjects() {
    const skills = Array.from(document.querySelectorAll<HTMLElement>('.skill'))
    const projects = Array.from(
        document.querySelectorAll<HTMLElement>('.projets > *'),
    )

    const linkProjects = Array.from(
        document.querySelectorAll<HTMLElement>('[data-show-related]'),
    )

    const skillsMap = new Map<string, HTMLElement>()

    for (const skill of skills) {
        skillsMap.set(skill.id.replace('-skill', ''), skill)
    }

    for (const project of projects) {
        const dataSkills = project.dataset.skills
        if (!dataSkills) continue

        const skills = dataSkills.trim().split(' ')
        const name = project.querySelector('h3')?.innerHTML ?? '<Nom Inconnu>'
        const skillList = project.querySelector('.related-skills')!

        for (const linkProject of linkProjects) {
            if (!skills.includes(linkProject.dataset.showRelated!)) continue

            const entry = document.createElement('li')
            entry.appendChild(createProjetReference(project.id, name))

            linkProject.appendChild(entry)
        }

        for (const skill of skills) {
            const skillElement = skillsMap.get(skill)!

            const entry = document.createElement('li')

            entry.appendChild(
                createSkillReference(
                    skillElement.id,
                    skillElement.querySelector('p')!.innerText,
                ),
            )

            skillList.appendChild(entry)
        }
    }
}
